import { render, staticRenderFns } from "./PanelNotice.vue?vue&type=template&id=5cd9537b&scoped=true"
import script from "./PanelNotice.vue?vue&type=script&lang=js"
export * from "./PanelNotice.vue?vue&type=script&lang=js"
import style0 from "./PanelNotice.vue?vue&type=style&index=0&id=5cd9537b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd9537b",
  null
  
)

export default component.exports